<template>
  <div class="c-app">
    <CWrapper>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view />
            </transition>
          </CContainer>
        </main>
        <Footer />
        <UserLoading v-if="loading" />
      </div>
    </CWrapper>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import UserLoading from "@/components/Loading";
import { mapState } from "vuex";

export default {
  name: "ErrorLayout",
  metaInfo() {
    return {
      title: "",
      titleTemplate: "株式会社 Fabbi"
    };
  },
  components: {
    Footer,
    UserLoading
  },
  computed: {
    ...mapState("layout", {
      loading: state => state.loading
    }),
    locale: function() {
      return this.$i18n.locale;
    }
  }
};
</script>
<style scoped>
.c-main {
  background-color: #ffff;
}
</style>
